import DodoneContext from 'app/dodones/Context'
import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'

export default ({ text = 'Bora' }) => {
  const { startDodone, updateDodone } = useContext(DodoneContext)

  return (
    <div className="input-group">
      <ConfirmableSpinnableButton
        className="btn btn-primary btn-block"
        onConfirm={startDodone}
        isSpinning={updateDodone.isPending}
        confirmation="Start?"
      >
        {text}
      </ConfirmableSpinnableButton>
    </div>
  )
}
